import { autoinject, transient } from "aurelia-dependency-injection";
import { VetClientModel, VetTaskClientModel } from "../../../../../../../../models/vetting/vetting.models";
import { prettyPrintJson } from "pretty-print-json";

@autoinject
@transient()
export class JsonPlugin {

    html: string;
    vet: VetClientModel;
    vetTask: VetTaskClientModel;
    async activate(model: { vet: VetClientModel, vetTask: VetTaskClientModel }) {
        this.vet = model.vet;
        this.vetTask = model.vetTask;
        if (this.vetTask.thirdPartyPayload) {
            const data = JSON.parse(this.vetTask.thirdPartyPayload);
            this.html = prettyPrintJson.toHtml(data), {
                indent: 100,
                linkUrls: true,
                quoteKeys: true
            };
        }
    }
}